/* eslint-disable */
import * as Types from '../../../../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetGrapeVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetGrapeDTO = (
  { __typename?: 'Query' }
  & { grape: (
    { __typename?: 'Grape' }
    & Pick<Types.GrapeDTO, 'id' | 'name' | 'archived'>
    & { temperatures?: Types.Maybe<Array<(
      { __typename?: 'TypeTemperature' }
      & Pick<Types.TypeTemperatureDTO, 'type' | 'temperature'>
    )>>, mainGrape?: Types.Maybe<(
      { __typename?: 'MainGrape' }
      & Pick<Types.MainGrapeDTO, 'id'>
    )> }
  ) }
);


export const GetGrapeDocumentDTO = gql`
    query getGrape($id: String!) {
  grape(id: $id) {
    id
    name
    temperatures {
      type
      temperature
    }
    mainGrape {
      id
    }
    archived
  }
}
    `;

/**
 * __useGetGrape__
 *
 * To run a query within a React component, call `useGetGrape` and pass it any options that fit your needs.
 * When your component renders, `useGetGrape` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrape({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGrape(baseOptions: Apollo.QueryHookOptions<GetGrapeDTO, GetGrapeVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGrapeDTO, GetGrapeVariablesDTO>(GetGrapeDocumentDTO, options);
      }
export function useGetGrapeLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetGrapeDTO, GetGrapeVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGrapeDTO, GetGrapeVariablesDTO>(GetGrapeDocumentDTO, options);
        }
export type GetGrapeHookResult = ReturnType<typeof useGetGrape>;
export type GetGrapeLazyQueryDTOHookResult = ReturnType<typeof useGetGrapeLazyQueryDTO>;
export type GetGrapeQueryResultDTO = Apollo.QueryResult<GetGrapeDTO, GetGrapeVariablesDTO>;